import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

class LocationMap extends Component {
    render() {
        const { lat, lng } = this.props;
        return (
            <div>
                <Map google={this.props.google}
                            zoom={14}
                            style={{ height: '400px', width: '400px' }}
                            initialCenter={{lat: lat ? lat : -32.9609108, lng: lng ? lng : -65.6432795}}
                            center={{lat: lat ? lat : -32.9609108, lng: lng ? lng : -65.6432795}}>
                                {
                                    (lat && lng) && <Marker position={{ lat: lat ? lat : -32.9609108, lng: lng ? lng : -65.6432795}} />
                                }
                </Map>
            </div>
        );
    }
}

LocationMap.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
};

export default GoogleApiWrapper({ apiKey: 'AIzaSyBUGNNkAGPeRPKvQNB5GOUvf29TajtcgEM' })(LocationMap);